<div class="card-body error">
  <div class="result-img">
    <span class="icon-ic_big_x"></span>
  </div>
  <div class="result-title">
    <p [innerHTML]="errorTitle | translate : { code: code | translate }"></p>
  </div>
  <button class="btn btn-link" (click)="goToSummary()">{{ "REFERENCE" | translate }} #{{ referenceNumber }}</button>
  <div class="result-text">
    <ng-container *ngIf="isCustomError">
      <p *ngFor="let m of error.messages" [innerHTML]="m.displayMessage | translate : { code: code | translate }"></p>
    </ng-container>
    <ng-container *ngIf="!isCustomError">
      <p [innerHTML]="errorText | translate : { code: code | translate }"></p>
    </ng-container>
  </div>
</div>
